(function ($) {

    $.fn.displaycalendar = function () {
        const calendrier = [
            "JANVIER",
            "FÉVRIER",
            "MARS",
            "AVRIL",
            "MAI",
            "JUIN",
            "JUILLET",
            "AOÛT",
            "SEPTEMBRE",
            "OCTOBRE",
            "NOVEMBRE",
            "DÉCEMBRE"
        ];

        return this.each(function () {
            let annee = $(this).find('.app-calendar-title').text().replace(/[^\d{4}]+/,'');
            let mois;
            let jour;

            $(this).find('.app-calendar-item').each(function () {
                jour = $(this).find('.app-calendar-day').text();
                mois = parseInt($.inArray($(this).find('.app-calendar-month').text(), calendrier))+1;
                mois = (mois < 10 ? '0' : '') + mois;

                $(this).addClass('tego-displaydate');
                $(this).attr('data-displaydate-max', annee + '-' + mois + '-' + jour);
                $(this).displaydate();
            });

            if(!$(this).find('.app-calendar-item:visible').length){
                $(this).hide();
            }

        });
    };

}(jQuery));